export class ToolRegistry {
  constructor() {
    this.tools = new Map();
    this.activeToolId = null;
  }

  register(tool) {
    this.tools.set(tool.id, tool);
  }

  setActive(toolId) {
    if (!this.tools.has(toolId)) {
      throw new Error(`Unknown tool: ${toolId}`);
    }

    this.activeToolId = toolId;
    return this.getActive();
  }

  getActive() {
    return this.tools.get(this.activeToolId) ?? null;
  }

  list() {
    return [...this.tools.keys()];
  }
}
